export const SKIP_SECONDS = 15;

export const PLAYBACK_RATES = [0.75, 1, 1.25, 1.5, 2] as const;

export function formatTime(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}
